import type {} from '@mui/lab/themeAugmentation';
import type {} from '@mui/x-data-grid-pro/themeAugmentation';
import { PropsWithChildren } from 'react';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles';
import {
  AlertComponent,
  AppBarComponent,
  AutocompleteComponent,
  ButtonComponent,
  CalendarPickerComponent,
  CardComponent,
  CardActionsComponent,
  CardContentComponent,
  CheckboxComponent,
  CircularProgressComponent,
  CssBaselineComponent,
  DataGridComponent,
  DialogComponent,
  DividerComponent,
  FormLabelComponent,
  FormControlComponent,
  IconButtonComponent,
  InputBaseComponent,
  InputLabelComponent,
  LinearProgressComponent,
  LinkComponent,
  ListComponent,
  MenuComponent,
  MenuItemComponent,
  MonthPickerComponent,
  OutlinedInputComponent,
  RatingComponent,
  SelectComponent,
  SliderComponent,
  SnackbarComponent,
  StepperComponent,
  SvgIconComponent,
  TabComponent,
  TabsComponent,
  TextFieldComponent,
  ToggleButtonComponent,
  TooltipComponent,
  TypographyComponent,
} from '../mui-components';
import baseTheme from './controllerBaseTheme';

export const controllerTheme = createTheme(baseTheme, {
  components: {
    ...AlertComponent,
    ...AppBarComponent,
    ...AutocompleteComponent,
    ...ButtonComponent,
    ...CalendarPickerComponent,
    ...CardComponent,
    ...CardActionsComponent,
    ...CardContentComponent,
    ...CheckboxComponent,
    ...CircularProgressComponent,
    ...CssBaselineComponent,
    ...DataGridComponent,
    ...DialogComponent,
    ...DividerComponent,
    ...FormLabelComponent,
    ...FormControlComponent,
    ...IconButtonComponent,
    ...InputBaseComponent,
    ...InputLabelComponent,
    ...LinearProgressComponent,
    ...LinkComponent,
    ...ListComponent,
    ...MenuComponent,
    ...MenuItemComponent,
    ...MonthPickerComponent,
    ...OutlinedInputComponent,
    ...RatingComponent,
    ...SelectComponent,
    ...SliderComponent,
    ...SnackbarComponent,
    ...StepperComponent,
    ...SvgIconComponent,
    ...TabComponent,
    ...TabsComponent,
    ...TextFieldComponent,
    ...ToggleButtonComponent,
    ...TooltipComponent,
    ...TypographyComponent,
  },
});

export function ControllerThemeProvider({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={controllerTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
